var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query, state } from 'lit/decorators.js';
import styles from '../../shared/sds-datepicker-item/_sds-date-picker-base.lit.scss';
import '../semi-annual-page-view/semi-annual-page-view';
import { getCurrentYear, isCurrentYear } from '../semi-annual-picker-calculations';
import { sdsCustomElement } from '../../../utilities/custom-components';
let SdsInnerSemiAnnualPicker = (() => {
    var _SdsInnerSemiAnnualPicker_selectedYear_accessor_storage, _SdsInnerSemiAnnualPicker_selectedSemiAnnual_accessor_storage, _SdsInnerSemiAnnualPicker_yearPageNavigation_accessor_storage, _SdsInnerSemiAnnualPicker__navigationState_accessor_storage, _SdsInnerSemiAnnualPicker__currentYear_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-inner-semi-annual-picker')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _selectedYear_decorators;
    let _selectedYear_initializers = [];
    let _selectedYear_extraInitializers = [];
    let _selectedSemiAnnual_decorators;
    let _selectedSemiAnnual_initializers = [];
    let _selectedSemiAnnual_extraInitializers = [];
    let _yearPageNavigation_decorators;
    let _yearPageNavigation_initializers = [];
    let _yearPageNavigation_extraInitializers = [];
    let __navigationState_decorators;
    let __navigationState_initializers = [];
    let __navigationState_extraInitializers = [];
    let __currentYear_decorators;
    let __currentYear_initializers = [];
    let __currentYear_extraInitializers = [];
    var SdsInnerSemiAnnualPicker = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsInnerSemiAnnualPicker_selectedYear_accessor_storage.set(this, __runInitializers(this, _selectedYear_initializers, void 0));
            _SdsInnerSemiAnnualPicker_selectedSemiAnnual_accessor_storage.set(this, (__runInitializers(this, _selectedYear_extraInitializers), __runInitializers(this, _selectedSemiAnnual_initializers, void 0)));
            _SdsInnerSemiAnnualPicker_yearPageNavigation_accessor_storage.set(this, (__runInitializers(this, _selectedSemiAnnual_extraInitializers), __runInitializers(this, _yearPageNavigation_initializers, void 0)));
            _SdsInnerSemiAnnualPicker__navigationState_accessor_storage.set(this, (__runInitializers(this, _yearPageNavigation_extraInitializers), __runInitializers(this, __navigationState_initializers, 'SelectSemiAnnual')));
            _SdsInnerSemiAnnualPicker__currentYear_accessor_storage.set(this, (__runInitializers(this, __navigationState_extraInitializers), __runInitializers(this, __currentYear_initializers, getCurrentYear())));
            this._intermediateSelectedYear = __runInitializers(this, __currentYear_extraInitializers);
            this.navigateForwardHandler = () => {
                this.navigateForward();
            };
            this.navigateBackHandler = () => {
                this.navigateBack();
            };
            this.selectYearHandler = (e) => {
                this.updateNavigationState('SelectSemiAnnual');
                this._intermediateSelectedYear = e.detail.year;
                this._currentYear = e.detail.year;
                this.setYearPageStateMapper();
            };
            this.selectSemiAnnualHandler = (e) => {
                this.selectedSemiAnnual = e.detail.selectedSemiAnnual;
                this.dispatchSemiAnnualSelected(true);
            };
            this.yearPageChangedHandler = (event) => {
                this.yearPageNavigation.startYear = event.detail.firstYearInPage;
                this.yearPageNavigation.endYear = event.detail.lastYearInPage;
            };
            this.changeYearPage = (event) => {
                this.changeYearPageBy(event.detail.step);
            };
        }
        get selectedYear() { return __classPrivateFieldGet(this, _SdsInnerSemiAnnualPicker_selectedYear_accessor_storage, "f"); }
        set selectedYear(value) { __classPrivateFieldSet(this, _SdsInnerSemiAnnualPicker_selectedYear_accessor_storage, value, "f"); }
        get selectedSemiAnnual() { return __classPrivateFieldGet(this, _SdsInnerSemiAnnualPicker_selectedSemiAnnual_accessor_storage, "f"); }
        set selectedSemiAnnual(value) { __classPrivateFieldSet(this, _SdsInnerSemiAnnualPicker_selectedSemiAnnual_accessor_storage, value, "f"); }
        get yearPageNavigation() { return __classPrivateFieldGet(this, _SdsInnerSemiAnnualPicker_yearPageNavigation_accessor_storage, "f"); }
        set yearPageNavigation(value) { __classPrivateFieldSet(this, _SdsInnerSemiAnnualPicker_yearPageNavigation_accessor_storage, value, "f"); }
        get _navigationState() { return __classPrivateFieldGet(this, _SdsInnerSemiAnnualPicker__navigationState_accessor_storage, "f"); }
        set _navigationState(value) { __classPrivateFieldSet(this, _SdsInnerSemiAnnualPicker__navigationState_accessor_storage, value, "f"); }
        get _currentYear() { return __classPrivateFieldGet(this, _SdsInnerSemiAnnualPicker__currentYear_accessor_storage, "f"); }
        set _currentYear(value) { __classPrivateFieldSet(this, _SdsInnerSemiAnnualPicker__currentYear_accessor_storage, value, "f"); }
        navigateForward() {
            switch (this._navigationState) {
                case 'SelectYear':
                    this.changeYearPageBy(1);
                    break;
                case 'SelectSemiAnnual':
                    ++this._currentYear;
                    break;
            }
        }
        navigateBack() {
            switch (this._navigationState) {
                case 'SelectYear':
                    this.changeYearPageBy(-1);
                    break;
                case 'SelectSemiAnnual':
                    --this._currentYear;
                    break;
            }
        }
        updateNavigationState(navigationState) {
            const oldValue = this._navigationState;
            this._navigationState = navigationState;
            this.requestUpdate('navigationState', oldValue);
        }
        updatePageIndex(pageYear) {
            if (pageYear !== undefined) {
                this._currentYear = pageYear;
            }
            this._intermediateSelectedYear = this.selectedYear;
        }
        render() {
            return html `
            <div class="sds-date-picker">${this.renderNavigation()} ${this.renderPageView()}</div>
        `;
        }
        renderNavigation() {
            switch (this._navigationState) {
                case 'SelectYear':
                    return html `
                    <sds-year-page-navigation
                        @sds.year-page-navigation.page-changed="${this.changeYearPage}"
                    ></sds-year-page-navigation>
                `;
                case 'SelectSemiAnnual':
                    return html `
                    <div class="sds-date-picker-toolbar">
                        <sds-button
                            class="sds-date-picker-toolbar__icon"
                            type="secondary"
                            size="md"
                            icon="arrow_left_thin"
                            @click="${this.navigateBackHandler}"
                        ></sds-button>
                        <sds-button
                            label="${this._currentYear}"
                            type="tertiary"
                            size="sm"
                            @click="${() => this.updateNavigationState('SelectYear')}"
                        >
                        </sds-button>
                        <sds-button
                            class="sds-date-picker-toolbar__icon"
                            type="secondary"
                            size="md"
                            icon="arrow_right_thin"
                            @click="${this.navigateForwardHandler}"
                        ></sds-button>
                    </div>
                `;
            }
        }
        willUpdate(_changedProperties) {
            if (_changedProperties.has('selectedYear')) {
                this._currentYear = this.selectedYear;
                this._intermediateSelectedYear = this.selectedYear;
            }
        }
        async updated() {
            await this.updateComplete;
            this.refreshYearPage();
        }
        renderPageView() {
            switch (this._navigationState) {
                case 'SelectSemiAnnual':
                    return html `
                    <sds-semi-annual-page-view
                        ?current="${isCurrentYear(this._currentYear)}"
                        selected-semi-annual="${this.getSelectedSemiAnnualForView()}"
                        @sds.semi-annual-page-view.changed="${this.selectSemiAnnualHandler}"
                    ></sds-semi-annual-page-view>
                `;
                case 'SelectYear':
                    return html `
                    <sds-year-page-view
                        @sds.year-page-view.page-changed="${this.yearPageChangedHandler}"
                        @sds.year-page-view.select="${this.selectYearHandler}"
                        current-year="${getCurrentYear()}"
                    >
                    </sds-year-page-view>
                `;
            }
        }
        refreshYearPage() {
            if (this._navigationState === 'SelectYear') {
                this.setYearPageStateMapper();
                this.setSelectedYearPage();
            }
        }
        setYearPageStateMapper() {
            var _a;
            (_a = this.getYearPageView()) === null || _a === void 0 ? void 0 : _a.setYearStateMapper(year => year === this._intermediateSelectedYear ? 'selected' : 'none');
        }
        setSelectedYearPage() {
            var _a, _b;
            (_a = this.getYearPageView()) === null || _a === void 0 ? void 0 : _a.openPageFor((_b = this._intermediateSelectedYear) !== null && _b !== void 0 ? _b : this._currentYear);
        }
        getYearPageView() {
            var _a;
            return ((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-year-page-view')) || undefined;
        }
        getSelectedSemiAnnualForView() {
            return this.selectedYear === this._currentYear ? this.selectedSemiAnnual : undefined;
        }
        changeYearPageBy(diff) {
            var _a;
            (_a = this.getYearPageView()) === null || _a === void 0 ? void 0 : _a.goByPage(diff);
        }
        dispatchSemiAnnualSelected(close) {
            this.dispatchEvent(new CustomEvent(SdsInnerSemiAnnualPicker.INNER_SEMI_ANNUAL_PICKER_CHANGED, {
                detail: {
                    selectedSemiAnnual: this.selectedSemiAnnual,
                    selectedYear: this._currentYear,
                    close: close,
                },
            }));
        }
    };
    _SdsInnerSemiAnnualPicker_selectedYear_accessor_storage = new WeakMap();
    _SdsInnerSemiAnnualPicker_selectedSemiAnnual_accessor_storage = new WeakMap();
    _SdsInnerSemiAnnualPicker_yearPageNavigation_accessor_storage = new WeakMap();
    _SdsInnerSemiAnnualPicker__navigationState_accessor_storage = new WeakMap();
    _SdsInnerSemiAnnualPicker__currentYear_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsInnerSemiAnnualPicker");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _selectedYear_decorators = [property({ type: Number, attribute: 'selected-year' })];
        _selectedSemiAnnual_decorators = [property({ type: Number, attribute: 'selected-semi-annual' })];
        _yearPageNavigation_decorators = [query('sds-year-page-navigation')];
        __navigationState_decorators = [state()];
        __currentYear_decorators = [state()];
        __esDecorate(_classThis, null, _selectedYear_decorators, { kind: "accessor", name: "selectedYear", static: false, private: false, access: { has: obj => "selectedYear" in obj, get: obj => obj.selectedYear, set: (obj, value) => { obj.selectedYear = value; } }, metadata: _metadata }, _selectedYear_initializers, _selectedYear_extraInitializers);
        __esDecorate(_classThis, null, _selectedSemiAnnual_decorators, { kind: "accessor", name: "selectedSemiAnnual", static: false, private: false, access: { has: obj => "selectedSemiAnnual" in obj, get: obj => obj.selectedSemiAnnual, set: (obj, value) => { obj.selectedSemiAnnual = value; } }, metadata: _metadata }, _selectedSemiAnnual_initializers, _selectedSemiAnnual_extraInitializers);
        __esDecorate(_classThis, null, _yearPageNavigation_decorators, { kind: "accessor", name: "yearPageNavigation", static: false, private: false, access: { has: obj => "yearPageNavigation" in obj, get: obj => obj.yearPageNavigation, set: (obj, value) => { obj.yearPageNavigation = value; } }, metadata: _metadata }, _yearPageNavigation_initializers, _yearPageNavigation_extraInitializers);
        __esDecorate(_classThis, null, __navigationState_decorators, { kind: "accessor", name: "_navigationState", static: false, private: false, access: { has: obj => "_navigationState" in obj, get: obj => obj._navigationState, set: (obj, value) => { obj._navigationState = value; } }, metadata: _metadata }, __navigationState_initializers, __navigationState_extraInitializers);
        __esDecorate(_classThis, null, __currentYear_decorators, { kind: "accessor", name: "_currentYear", static: false, private: false, access: { has: obj => "_currentYear" in obj, get: obj => obj._currentYear, set: (obj, value) => { obj._currentYear = value; } }, metadata: _metadata }, __currentYear_initializers, __currentYear_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsInnerSemiAnnualPicker = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.INNER_SEMI_ANNUAL_PICKER_CHANGED = 'sds.inner-semi-annual-picker.changed';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsInnerSemiAnnualPicker = _classThis;
})();
export { SdsInnerSemiAnnualPicker };
